import _ from 'lodash'
import { PagesPlatformApplications } from 'thunderbolt-viewer-manager-types'

const WIX_CODE_APP_DEF_ID = '675bbcef-18d8-41f5-800e-131ec9e08762'
export function transformToTbStructure(pagesPlatformApplications: PagesPlatformApplications) {
	if (pagesPlatformApplications.wixCode) {
		// this is a temporary workaround until DS will remove the transformation in their side
		// https://jira.wixpress.com/browse/DM-4393
		pagesPlatformApplications[WIX_CODE_APP_DEF_ID] = pagesPlatformApplications.wixCode
		delete pagesPlatformApplications.wixCode
	}
	return _.transform<any, any>(
		pagesPlatformApplications,
		function (result: any, pageIds: string, appId: string) {
			_.forOwn(pageIds, function (value, pageId) {
				result[pageId] = result[pageId] || []
				result[pageId].push(appId)
			})
		},
		{}
	)
}
